import { ETTypeInfos } from "@cervval.js/common-dto/src/dtoModel.service";
import { keys, typeInfos } from "@cervval.js/ts-reflect";
import { UsersElementTypes } from "../users/user.model";
import { ContactDTO, GroupDiscussionDTO, MessageDeliveryDTO, MessageDTO } from "./message.dto";
import { NoteDTO } from "./note.dto";

export type CommunicationElementTypes = {
    "notes": NoteDTO,
    "messages": MessageDTO,
    "message_deliveries": MessageDeliveryDTO,
    "contact": ContactDTO,
    "group_discussion": GroupDiscussionDTO
}

export type CommunicationElementTypeNames = keyof CommunicationElementTypes;
export const CommunicationElementTypeNames: CommunicationElementTypeNames[] = keys<CommunicationElementTypes>();

export const communicationTypeInfos: ETTypeInfos<CommunicationElementTypes, CommunicationElementTypes & UsersElementTypes> = {
    "notes": {
        keys: keys<NoteDTO>(),
        typeInfos: typeInfos<NoteDTO>(),
        foreignKeys: {
            ownerId: "user_profiles",
            targetUserId: "user_profiles"
        }
    },
    "messages": {
        keys: keys<MessageDTO>(),
        typeInfos: typeInfos<MessageDTO>(),
        foreignKeys: {
            senderId: "user_profiles",
            replyToId: "messages",
            recipientId: "group_discussion"
        },
        archivedField: "archived"
    },
    "message_deliveries": {
        keys: keys<MessageDeliveryDTO>(),
        typeInfos: typeInfos<MessageDeliveryDTO>(),
        foreignKeys: {
            recipientId: "user_profiles",
            messageId: "messages"
        },
        archivedField: "archived"
    },
    "contact": {
        keys: keys<ContactDTO>(),
        typeInfos: typeInfos<ContactDTO>()
    },
    "group_discussion": {
        keys: keys<GroupDiscussionDTO>(),
        typeInfos: typeInfos<GroupDiscussionDTO>()

    }
};